<template>
  <div class="pp-thumb" :style="{ paddingTop: `${ratio * 100}%` }">
    <div class="pp-thumb__skeleton" />
    <iframe
      v-if="width > 0"
      class="pp-thumb__frame"
      :src="src"
      :title="`Modelo ${template}`"
      :style="frameStyle"
      loading="lazy"
      tabindex="-1"
      aria-hidden="true"
      scrolling="no"
      @load="loaded = true"
    />
  </div>
</template>

<script>
import { templatePreviewUrl } from "@/services/publicProfile";

// Miniatura do modelo: a pagina de exemplo do front publico renderizada em
// tamanho de computador e reduzida por transform. Sem clique dentro.
export default {
  name: "TemplateThumb",
  props: {
    template: { type: String, required: true },
    virtualWidth: { type: Number, default: 1280 },
    virtualHeight: { type: Number, default: 800 },
  },
  data: () => ({ width: 0, loaded: false }),
  computed: {
    ratio() {
      return this.virtualHeight / this.virtualWidth;
    },
    src() {
      return templatePreviewUrl(this.template);
    },
    frameStyle() {
      const scale = this.width / this.virtualWidth;
      return {
        width: `${this.virtualWidth}px`,
        height: `${this.virtualHeight}px`,
        transform: `scale(${scale})`,
        opacity: this.loaded ? 1 : 0,
      };
    },
  },
  mounted() {
    this.measure();
    if (typeof window.ResizeObserver === "function") {
      this.observer = new window.ResizeObserver(() => this.measure());
      this.observer.observe(this.$el);
    } else {
      window.addEventListener("resize", this.measure);
    }
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
    window.removeEventListener("resize", this.measure);
  },
  methods: {
    measure() {
      if (this.$el) this.width = this.$el.clientWidth;
    },
  },
};
</script>

<style lang="scss">
.pp-thumb {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #e7edf0;

  &__skeleton {
    position: absolute;
    inset: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, #ebecf0 0%, #fafbfc 50%, #ebecf0 100%);
    background-size: 200% 100%;
    animation: pp-shimmer 1.5s linear infinite;
  }

  &__frame {
    position: absolute;
    top: 0;
    left: 0;
    border: 0;
    transform-origin: 0 0;
    pointer-events: none;
    background: #fff;
    transition: opacity 0.3s ease;
  }
}

@keyframes pp-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
